// Import htmx and extensions
import htmx from "htmx.org";
import "htmx-ext-alpine-morph";
import "htmx-ext-ws";
import "htmx-ext-debug";
import "htmx-ext-class-tools";
import "htmx-ext-loading-states";
import "htmx-ext-response-targets";
// hyperscript.org ≥0.9.91 is a side-effect ESM module: it self-initializes in
// the browser and assigns itself to window._hyperscript on import.
import "hyperscript.org";

// Make htmx globally available
window.htmx = htmx;

// Initialize all extensions after Alpine is ready
document.addEventListener("alpine:init", () => {
  // Initialize with Alpine's morph plugin
  htmx.defineExtension("alpine-morph", {
    morph: (target, content) => {
      Alpine.morph(target, content);
    },
  });
});

// Uncomment below code snippet to enable htmx logging
// window.htmx.logger = function (elt, event, data) {
//   if (console) {
//     console.log(event, elt, data);
//   }
// };

document.addEventListener("htmx:afterRequest", (event) => {
  // Add null check for xhr
  if (event.detail.xhr) {
    const hxRedirect = event.detail.xhr.getResponseHeader("hx-redirect");
    if (hxRedirect && hxRedirect === window.location.pathname + window.location.hash) {
      window.location.reload();
    }
  }
});

// Handle 4xx responses by targeting the element specified in hx-target-{status}
// This replaces the htmx-ext-response-targets extension which has webpack bundling issues
document.addEventListener("htmx:beforeSwap", (event) => {
  const xhr = event.detail.xhr;
  if (xhr && xhr.status >= 400 && xhr.status < 500) {
    const status = xhr.status;
    const elt = event.detail.requestConfig?.triggeringEvent?.target;

    if (elt) {
      // Look for hx-target-{status} attribute (e.g., hx-target-422)
      const targetSelector = elt.getAttribute(`hx-target-${status}`);
      if (targetSelector) {
        const target = document.querySelector(targetSelector);
        if (target) {
          event.detail.shouldSwap = true;
          event.detail.target = target;
          // Check for custom swap strategy
          const swapValue = elt.getAttribute(`hx-swap-${status}`) || "innerHTML";
          event.detail.swapOverride = swapValue;
        }
      }
    }
  }
});

// Initialize Flowbite after DOM content and htmx updates
const initFlowbiteIfReady = () => {
  if (typeof initFlowbite === "function" && document.readyState === "complete") {
    try {
      initFlowbite();
      // Dispatch event to signal Flowbite is ready
      document.dispatchEvent(new CustomEvent("flowbite:initialized"));
    } catch (e) {
      console.warn("Flowbite initialization failed:", e);
    }
  }
};

document.addEventListener("DOMContentLoaded", initFlowbiteIfReady);
document.addEventListener("readystatechange", initFlowbiteIfReady);
htmx.on("htmx:afterSettle", initFlowbiteIfReady);
